import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SessionExpiredService } from './sessionExpired.service';

// SSO users must never land on the login page. Any redirect to '/' (e.g.
// AuthGuardfor, component error handlers) is cancelled here: an active SSO
// session goes back to /sso, an ended one gets the "session expired" popup
// whose button closes the tab.
@Injectable({ providedIn: 'root' })
export class SsoLoginBlockGuard implements CanActivate {
  constructor(private sessionExpired: SessionExpiredService, private cookie: CookieService, private router: Router) { }

  canActivate(): boolean {
    if (!this.sessionExpired.isSsoSession()) {
      return true;
    }

    if (this.cookie.get('token')) {
      // Still signed in (some code may have cleared localStorage only):
      // restore the SSO flags SsoGuard/SsoRestrictGuard rely on and go home.
      this.cookie.set('sso_user', 'true');
      localStorage.setItem('sso_user', 'true');
      this.router.navigate(['/sso']);
    } else {
      this.sessionExpired.endSsoSession();
      this.sessionExpired.showClosePopup();
    }
    return false;
  }
}
